
import { z } from 'zod';
import { SLOT_MS } from './slots.ts';

export const MAX_UNAVAILABILITY_REASON_LENGTH = 200;

export const unavailabilityReason = z
  .string()
  .trim()
  .max(MAX_UNAVAILABILITY_REASON_LENGTH, `Keep the reason under ${MAX_UNAVAILABILITY_REASON_LENGTH} characters.`)
  .transform((s) => (s.length === 0 ? undefined : s))
  .optional();

const slotAlignedInstant = z
  .string()
  .datetime({ offset: true, message: 'Must be an ISO-8601 instant.' })
  .refine((s) => new Date(s).getTime() % SLOT_MS === 0, {
    message: 'Must fall on a 30-minute boundary.',
  });

export const BookSlotInputSchema = z
  .object({
    listingId: z.string().uuid({ message: 'Invalid listing id.' }),
    start: slotAlignedInstant,
    end: slotAlignedInstant,
  })
  .refine((v) => new Date(v.end).getTime() > new Date(v.start).getTime(), {
    message: 'End must be after start.',
    path: ['end'],
  });

export type BookSlotInput = z.infer<typeof BookSlotInputSchema>;

export const CancelBookingInputSchema = z.object({
  bookingId: z.string().uuid({ message: 'Invalid booking id.' }),
});

export type CancelBookingInput = z.infer<typeof CancelBookingInputSchema>;

export const AddUnavailabilityInputSchema = z
  .object({
    listingId: z.string().uuid({ message: 'Invalid listing id.' }),
    start: slotAlignedInstant,
    end: slotAlignedInstant,
    reason: unavailabilityReason,
  })
  .refine((v) => new Date(v.end).getTime() > new Date(v.start).getTime(), {
    message: 'End must be after start.',
    path: ['end'],
  });

export type AddUnavailabilityInput = z.infer<typeof AddUnavailabilityInputSchema>;

export const EditUnavailabilityReasonInputSchema = z.object({
  unavailabilityId: z.string().uuid({ message: 'Invalid unavailability id.' }),
  reason: unavailabilityReason,
});

export type EditUnavailabilityReasonInput = z.infer<typeof EditUnavailabilityReasonInputSchema>;

export const RemoveUnavailabilityInputSchema = z.object({
  unavailabilityId: z.string().uuid({ message: 'Invalid unavailability id.' }),
});

export type RemoveUnavailabilityInput = z.infer<typeof RemoveUnavailabilityInputSchema>;
